import { useEffect } from "react";

const BASE_TITLE = "Livinora";
const DEFAULT_SUFFIX = "Interior Concepts für Ferienobjekte";

export default function useDocumentTitle(title, description) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${BASE_TITLE}` : `${BASE_TITLE} — ${DEFAULT_SUFFIX}`;
    document.title = fullTitle;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [title, description]);
}
